import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { DEPRECATED_Card, Loading, useConfig, useTranslations } from "@jti/ui";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import getCartItemsCount from "../../utils/getCartItemsCount";
import SummaryCartBundleItem from "./SummaryCartBundleItem";
import SummaryCartItem from "./SummaryCartItem";
import styles from "./SummaryCartItems.module.scss";
export const SummaryCartItems = ({ items, isLoading = false }) => {
    const { __ } = useTranslations();
    const config = useConfig();
    const { isFreeTrial } = useFreeTrial();
    const itemsCount = getCartItemsCount(items);
    let cardTitle = __("cart.item_summary.title", [itemsCount]);
    if (itemsCount === 1) {
        cardTitle = __("cart.item_summary.single.title", [], cardTitle);
    }
    const sortedItems = [...items].sort((a, b) => Number(a.isGift) - Number(b.isGift));
    return isLoading ? (_jsx(Loading, {})) : (_jsx(DEPRECATED_Card, { variant: "variant6", iconVariant: "arrow", title: cardTitle, className: styles.container, classNameTitle: styles.containerTitle, classNameContent: styles.containerContent, isCollapsible: true, collapsed: true, children: _jsx("ul", { className: styles.list, children: sortedItems.map((item) => (item.type_id === "bundle" || item.product_type === "bundle") && config.displayBundleSelectedItems ? (_createElement(SummaryCartBundleItem, { ...item, key: item.sku, isFreeTrial: isFreeTrial })) : (_createElement(SummaryCartItem, { ...item, key: item.sku, isFreeTrial: isFreeTrial }))) }) }));
};
//# sourceMappingURL=SummaryCartItems.js.map